export const KUESKI_SESSION_STORAGE_KEY = 'kueski_session';
export const ACCESS_TOKEN_STORAGE_KEY = 'KPAY_ACCESS_TOKEN';
export const CLOSE_AUTH0_SESSION = 'CLOSE_AUTH0_SESSION';
export const EMAIL_KEY = 'email';
